import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  campaigns: [],
};

export const campaignSlice = createSlice({
  name: "Campaign",
  initialState,
  reducers: {
    setCampaign: (state, action) => {
      state.campaigns = action.payload;
    },
  },
});

export const { setCampaign } = campaignSlice.actions;
export const campaignReducer = campaignSlice.reducer;